import { useAppDispatch } from "core/utils";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

import { BASE_PATH } from "../../core/router/types/routerTypes";
import { hideNotification } from "../../core/setup/redux/state/notifications/notificationsState";

/**
 * Component that listens to route changes and automatically hides notifications
 * when the user navigates away from the current resource (first path segment).
 */
export const NotificationRouteListener = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    const prevFirstSegmentRef = useRef<string | undefined>(undefined);

    useEffect(() => {
        const getFirstPathSegment = (pathname: string) => {
            // Strip the BASE_PATH prefix so the first segment is the meaningful resource segment
            // e.g. "/administration/v4/loyalty-messages" → "loyalty-messages"
            const stripped = BASE_PATH ? pathname.replace(BASE_PATH, "") : pathname;
            return stripped.split("/").find(Boolean);
        };
        const currentFirstSegment = getFirstPathSegment(location.pathname);

        if (prevFirstSegmentRef.current !== undefined && prevFirstSegmentRef.current !== currentFirstSegment) {
            dispatch(hideNotification());
        }
        prevFirstSegmentRef.current = currentFirstSegment;
    }, [location.pathname, dispatch]);

    return null;
};
